/**
 * Centralized Logger Utility
 * TASK-335: AI Assistant Configuration & Restrictions
 *
 * Environment-aware logging that only outputs in development mode.
 * Prevents log pollution in production builds.
 *
 * Accepts variadic arguments to match console.* signatures.
 */

const isDev = import.meta.env.DEV;

export const logger = {
  /** Log error messages (only in development) */
  error: (...args: unknown[]): void => {
    if (isDev) console.error(...args);
  },

  /** Log warning messages (only in development) */
  warn: (...args: unknown[]): void => {
    if (isDev) console.warn(...args);
  },

  /** Log debug messages (only in development) */
  debug: (...args: unknown[]): void => {
    if (isDev) console.debug(...args);
  },

  /** Log info messages (only in development) */
  info: (...args: unknown[]): void => {
    if (isDev) console.info(...args);
  },
};

export default logger;
